import { render } from "./InputEmail.vue?vue&type=template&id=5a5adc6b"
import script from "./InputEmail.vue?vue&type=script&lang=js"
export * from "./InputEmail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__